var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilWriting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pencil Writing"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.49609 11.5829L6.74658 11.9762L7.13916 9.22592L14.2099 2.15513C14.5225 1.84258 14.9464 1.66699 15.3884 1.66699C15.8304 1.66699 16.2543 1.84258 16.5669 2.15513C16.8794 2.46768 17.055 2.89158 17.055 3.33359C17.055 3.7756 16.8794 4.19951 16.5669 4.51206L9.49609 11.5829Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.2778 11.6673V17.2226C14.2778 17.5173 14.1607 17.7999 13.9524 18.0083C13.744 18.2166 13.4614 18.3337 13.1667 18.3337H2.05613C1.76146 18.3337 1.47885 18.2166 1.27049 18.0083C1.06213 17.7999 0.945068 17.5173 0.945068 17.2226V6.11204C0.945068 5.81737 1.06213 5.53476 1.27049 5.3264C1.47885 5.11803 1.76146 5.00098 2.05613 5.00098H7.61143",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilWriting);
export default __webpack_public_path__ + "static/media/pencil-writing.04d2e95b.svg";
export { ForwardRef as ReactComponent };